import React from 'react'

import { DynamicContentContext } from '@scoir/college-content'
import { noop } from 'lodash'
import PropTypes from 'prop-types'

const DynamicContentProvider = ({ children }) => {
  return (
    <DynamicContentContext.Provider
      value={{
        onPlayVideo: noop,
      }}
    >
      {children}
    </DynamicContentContext.Provider>
  )
}
DynamicContentProvider.propTypes = {
  children: PropTypes.any.isRequired,
}

export default DynamicContentProvider
